import React, { useState } from "react";
import { Mail, MapPin, Send } from "lucide-react";
import { useToast, ToastContainer } from "../components/Toast";
import Loading from "../components/Loading";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toasts, success, error } = useToast();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Simulate random success/error for demo
      if (Math.random() > 0.3) {
        success(
          "Thank you for your message! We'll get back to you within 24 hours."
        );
        setFormData({ name: "", email: "", message: "" });
      } else {
        throw new Error("Failed to send message");
      }
    } catch (err) {
      error("Failed to send message. Please try again or contact us directly.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <main className="contact-page">
        <section className="section">
          <div className="container">
            <h1 className="page-title text-center">Contact Us</h1>
            <div className="contact-content">
              <div className="contact-info">
                <h2>Get in Touch</h2>
                <p>
                  Have questions about ProSkillNest? We'd love to hear from you.
                  Send us a message and we'll respond as soon as possible.
                </p>

                <div className="contact-details">
                  <div className="contact-item">
                    <div className="contact-item-header">
                      <Mail size={20} />
                      <h3>Email</h3>
                    </div>
                    <p>info@proskillnest.com</p>
                  </div>

                  <div className="contact-item">
                    <div className="contact-item-header">
                      <MapPin size={20} />
                      <h3>Address</h3>
                    </div>
                    <p>Remote (Worldwide)</p>
                  </div>
                </div>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <Loading size="small" text="" />
                  ) : (
                    <>
                      <Send size={18} />
                      Send Message
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </section>
      </main>
      <ToastContainer toasts={toasts} position="top-right" />
    </>
  );
};

export default Contact;
